import { render } from "./PreRegistration.vue?vue&type=template&id=33887a48&scoped=true"
import script from "./PreRegistration.vue?vue&type=script&lang=js"
export * from "./PreRegistration.vue?vue&type=script&lang=js"

import "./PreRegistration.vue?vue&type=style&index=0&id=33887a48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33887a48"]])

export default __exports__